import { c as _c } from "react/compiler-runtime";
import Lightbox from '@precis-digital/kurama/Lightbox';
import { type ReactElement } from 'react';
import { useTranslation } from 'shared/translations';
export interface CopilotImageLightboxProps {
  imageUrl: string;
  /** Real name where the file still has a record, a generic label otherwise. */
  filename: string;
  onClose: () => void;
  /** Same handler the thumbnail uses, so an expired URL is re-signed once. */
  onImageError?: () => void;
}

/** The header shows a picture's name, not its file type — drop the extension for display. */
const stripExtension = (name: string): string => {
  const dotIndex = name.lastIndexOf('.');
  return dotIndex > 0 ? name.slice(0, dotIndex) : name;
};

/**
 * Copilot's own wiring over Kurama's generic `Lightbox`: translated copy and
 * the display name.
 */
export const CopilotImageLightbox = t0 => {
  const $ = _c(14);
  const {
    imageUrl,
    filename,
    onClose,
    onImageError
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "copilot.imageViewer"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  let t2;
  if ($[1] !== t) {
    t2 = t("alt");
    $[1] = t;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== filename) {
    t3 = stripExtension(filename);
    $[3] = filename;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("close");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== imageUrl || $[8] !== onClose || $[9] !== onImageError || $[10] !== t2 || $[11] !== t3 || $[12] !== t4) {
    t5 = <Lightbox imageUrl={imageUrl} imageAlt={t2} filename={t3} onClose={onClose} closeLabel={t4} onImageError={onImageError} />;
    $[7] = imageUrl;
    $[8] = onClose;
    $[9] = onImageError;
    $[10] = t2;
    $[11] = t3;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};